export enum OrderAutoFillEnum {
  No = 0, // 不補
  BottomToTop = 1, // 由下往上
  TopToBottom = 2, // 由上往下
}
